import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import List from "./List";
import { fetchIntroductionScreens } from "../../redux/slice/introductionScreenSlice";
import { useNavigate } from "react-router-dom";

const IntroductionScreens = () => {
    const dispatch = useDispatch();
    const { setLoading } = useLoader();
    const headerPortalTarget = document.getElementById("header-portal-target");

    const headerContent = (
        <div className="d-flex align-items-center justify-content-between w-100">
            <h4 className="fw-semibold mb-0 text-primary fs-lg">
                Intro Screens
            </h4>
        </div>
    );
    const [limit, setLimit] = useState({ value: 10, label: 10 });

    const { list = [], isLoading, total } = useSelector((state) => state.introductionScreens || {});

    const [searchTerm, setSearchTerm] = useState("");
    // const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const isInitialLoadRef = useRef(true);
    const searchTimeout = useRef(null);

    useEffect(() => {
        //     const timer = setTimeout(() => {
        //         setDebouncedSearchTerm(searchTerm);
        //     }, 500);

        //     return () => clearTimeout(timer);
        // }, [searchTerm]);

        // const fetchData = useCallback(() => {
        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }

        const fetchData = () => {
            if (isInitialLoadRef.current) {
                setLoading(true);
            }
            dispatch(
                fetchIntroductionScreens({
                    // search: debouncedSearchTerm,
                    page: currentPage,
                    search: searchTerm,
                    limit: limit?.value,
                })
                //     );
                // }, [dispatch, debouncedSearchTerm, currentPage, limit?.value]);

                // 
            ).finally(() => {
                if (isInitialLoadRef.current) {
                    setLoading(false);
                    isInitialLoadRef.current = false;
                }
            });
        };

        if (isInitialLoadRef.current) {
            fetchData();
            // }, [fetchData]);

            // useEffect(() => {
            //     if (!debouncedSearchTerm && list?.length === 0) {
            //         setLoading(isLoading);
            // }, [fetchData]);

            // useEffect(() => {
            //     if (!debouncedSearchTerm && list?.length === 0) {
            //         setLoading(isLoading);
        } else {
            //         setLoading(false);


            // }, [isLoading, setLoading, list?.length, debouncedSearchTerm]);
            searchTimeout.current = setTimeout(fetchData, 500);
        }

        return () => {
            if (searchTimeout.current) {
                clearTimeout(searchTimeout.current);
            }
        };
    }, [searchTerm, currentPage, limit?.value, dispatch, setLoading]);

    const handleSearchChange = (value) => {
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handleEditBtn = (item) => {
        navigate(`/introduction-screens/edit/${item.id}`, {
            state: { item, isEdit: true },
        });
    };

    const handleViewBtn = (item) => {
        navigate(`/introduction-screens/edit/${item.id}`, {
            state: { item, isView: true },
        });
    };


    const paginationConfig = useMemo(() => ({
        currentPage,
        totalPages: Math.ceil(total / limit?.value) || 1,
        total: total || 0,
        onPageChange: (page) => setCurrentPage(page),
        pageSize: limit?.value,
        setPageSize: (size) => setLimit({ value: size, label: size }),
        setCurrentPage
    }), [currentPage, total, limit]);

    return (
        <>
            {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}
            <Container fluid className="px-0">
                <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
                    <List
                        data={list}
                        isLoading={isLoading}
                        isInitialLoad={isInitialLoadRef.current}
                        searchTerm={searchTerm}
                        setSearchTerm={handleSearchChange}
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        handleEditBtn={handleEditBtn}
                        onView={handleViewBtn}
                        // refresh={fetchData}
                        refresh={() => {
                            dispatch(
                                fetchIntroductionScreens({
                                    search: searchTerm,
                                    page: currentPage,
                                    limit: limit?.value,
                                })
                            );
                        }}
                        limit={limit?.value}
                        pagination={paginationConfig}
                    />
                </div>
            </Container>
        </>
    );
};
export default IntroductionScreens;